import React, { Suspense } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';
import './styles/common.scss'
import { useContext, useEffect } from 'react'
import AuthContext from './store/auth-context'
import Layout from './components/Layout/Layout'
import LoadingSpinner from './components/Layout/LoadingSpinner'
import { authenticateSession } from './services/AuthService'
import Logger from 'js-logger'

const SearchPage = React.lazy(() => import('./pages/SearchPage'))
const LoginPage = React.lazy(() => import('./pages/LoginPage'))
const PlayerPage = React.lazy(() => import('./pages/PlayerPage'))

function App(props) {
  const authCtx = useContext(AuthContext)
  Logger.useDefaults()
  if (props.config.env === 'prod') {
    Logger.setLevel(Logger.WARN)
  }
  Logger.debug('Starting with following settings: ', authCtx.isLoggedIn, authCtx.authCheckStatus, authCtx.userRole, props.config)

  useEffect(() => {
    authenticateSession(props.config, authCtx)
  }, [authCtx, props.config])

  return (
    <Layout>
    <Suspense fallback={<div className='centered'><LoadingSpinner /></div>}>
      { !authCtx.isLoggedIn && authCtx.authCheckStatus === 'valid' && (
        <Switch>
          <Route path="*">
            <LoginPage config={props.config} />
          </Route>
        </Switch>
      ) }
      { authCtx.isLoggedIn && authCtx.userRole && (
        <Switch>
          <Route path='/' exact>
            <Redirect to='/kategoria/kaikki'/>
          </Route>
          <Route path="/kategoria/:filterId">
            <SearchPage config={props.config} />
          </Route>
          <Route path="/haku/:searchParam">
            <SearchPage config={props.config} />
          </Route>
          <Route path="/asset/:assetId">
            <PlayerPage config={props.config} />
          </Route>
          <Route path="/liiga/haku/:searchParam">
            { authCtx.userRole === 'liiga' ? <SearchPage config={props.config} /> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/liiga/:filterId">
            { authCtx.userRole === 'liiga' ? <SearchPage config={props.config} /> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/liiga">
            { authCtx.userRole === 'liiga' ? <Redirect to='/liiga/kaikki'/> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/mestis/haku/:searchParam">
            { authCtx.userRole === 'mestis' ? <SearchPage config={props.config} /> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/mestis/:filterId">
            { authCtx.userRole === 'mestis' ? <SearchPage config={props.config} /> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/mestis">
            { authCtx.userRole === 'mestis' ? <Redirect to='/mestis/kaikki'/> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/suomiareena/haku/:searchParam">
            { authCtx.userRole === 'suomiareena' ? <SearchPage config={props.config} /> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/suomiareena/:filterId">
            { authCtx.userRole === 'suomiareena' ? <SearchPage config={props.config} /> : <LoginPage config={props.config} /> }
          </Route>
          <Route path="/suomiareena">
            { authCtx.userRole === 'suomiareena' ? <Redirect to='/suomiareena/kaikki'/> : <LoginPage config={props.config} /> }
          </Route>
          <Route path='*'>
            <Redirect to='/'/>
          </Route>
        </Switch>
      )}
    </Suspense>
    </Layout>
  )
}

export default App
